import { MaintenanceStrategyTableModel } from "../../tables/archive/maintenance-strategy-table.model";
import { MaintenanceRoutineSupplyTableModel } from "../../tables/maintenance/maintenance-routine-supply-table.model";
import { MaintenanceRoutineDetailPrintModel } from "./maintenance-routine-detail-print.model";

export class MaintenanceRoutinePrintModel {
  maintenanceRoutineId: number = 0;
  companyId: number = 0;
  articleCode: number = 0;
  companyName: string = '';
  articleCodeName: string = '';
  maintenanceStrategies: MaintenanceStrategyTableModel[] = [];
  maintenanceActivities: MaintenanceRoutineDetailPrintModel[] = [];
  maintenanceRoutineSupplies: MaintenanceRoutineSupplyTableModel[] = [];
}